import NewsAngBlogListItem from 'Features/News/Components/NewsAngBlogListItem'
import Paging from 'Features/Paging/paging'
import useQueryParams from 'Frontend/hooks/useQueryParams'
import { ICommunityNewsItem, ICommunityNewsSearchResults } from 'Frontend/scripts/models/communityNews.model'
import { getCommunityNews } from 'Frontend/scripts/services/communityNews.services'
import { FunctionComponent, useEffect, useState } from 'react'

type CommunityNewsListingProps = {
  pageId: string
}

const CommunityNewsListing: FunctionComponent<CommunityNewsListingProps> = ({ pageId }) => {
  const { getQueryParam } = useQueryParams()
  const [news, setNews] = useState<ICommunityNewsSearchResults | null>(null)
  const [activePage, setActivePage] = useState<number>(
    getQueryParam('page') ? parseInt(getQueryParam('page') as string) : 1,
  )

  const getNewsResult = () => {
    getCommunityNews(activePage, pageId).then((result) => {
      setNews(result)
    })
  }

  useEffect(() => {
    getNewsResult()
  }, [activePage])

  return (
    <div className="newslist" id="news">
      {news?.newsPosts?.map((item: ICommunityNewsItem) => (
        <NewsAngBlogListItem newsItem={item} key={item.contentLink.id} commentCollection={item.comments} />
      ))}
      {news?.newsPosts && (
        <Paging
          activePage={activePage || 1}
          noOfPages={news.numberOfPages}
          callback={(pageIndex: number) => setActivePage(pageIndex)}
        />
      )}
    </div>
  )
}

export default CommunityNewsListing
